import React, { useCallback, useState } from 'react'
import { outsideClickHandler } from '@usap/core'
import { useStaticProps } from '../../../../../../../contexts/staticProps.context'

import CoreWmo from './CoreWmo'

const Core = props => {
  const { data } = props
  const { product } = data
  const [showInformation, shouldShowInformation] = useState(false)
  const staticProps = useStaticProps()

  const handleShowInformation = useCallback(
    () => {
      outsideClickHandler(
        showInformation,
        [`iconClick${product.productId}`],
        () => {
          shouldShowInformation(false)
        },
      )
      shouldShowInformation(!showInformation)
    },
    [product.productId, showInformation],
  )

  if (!data?.price?.core || Number(data?.price?.core) === 0) {
    return null
  }

  return (
    <CoreWmo
      handleShowInformation={handleShowInformation}
      product={product}
      showInformation={showInformation}
      data={data}
      staticProps={staticProps}
    />
  )
}

export default Core
